<template>
<div class="mt-5" v-if="this.user !== null">
  <v-snackbar v-model="snackbar" :color="color" :multi-line="mode === 'multi-line'" :timeout="timeout" :vertical="mode === 'vertical'">
    {{ text }}
    <v-btn dark flat @click="snackbar = false">
      <v-icon>cancel</v-icon>
    </v-btn>
  </v-snackbar>
  <!-- Class Join Confirmation Modal -->
  <v-dialog v-if="confirmJoin && inviteGroup !== null" v-model="confirmJoin" width="500">
    <v-card>
      <v-card-title class="headline green darken-2" primary-title>
        Join {{inviteGroup.projectTitle}}?
      </v-card-title>

      <v-card-text>
        <div class="text-uppercase text-left text-dark"># of Members</div>
        <div class="text-center text-primary">{{inviteGroup.members.length}}</div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="confirmJoin=false" class="btn modal-btn">Cancel</v-btn>
        <v-btn @click="joinProject" class="btn btn-primary modal-btn">Join</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <div class="dashboardBody">
    <div class="empty container">
      <div class="loader" v-if="isLoading">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <v-container fluid v-else>
        <v-layout grid wrap justify-center>
          <v-flex xs12 sm6 class="my-4">
            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3 v-if="this.projectSets === null" class="py-2 mb-2 red--text d-inline-block">You don't have any Projects! <v-icon color="red">arrow_forward</v-icon></h3>
                  <h2 v-else class="py-2">Existing projects</h2>
                </v-flex>
                <v-flex xs12 sm6 v-for="(group, index) in projectSets" :key="index">
                  <router-link :to="{ name: 'home', params: { groupID: group.id } }" active-class="green--text">
                    <v-card>
                      <v-card-text class="px-0">
                        {{ group.projectTitle }}
                        <v-icon small>open_in_new</v-icon>
                      </v-card-text>
                    </v-card>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 sm4 offset-sm2 class="my-4">
            <v-card>
              <h2 class="py-2">Create a new project</h2>
              <v-divider></v-divider>
              <div class="empty-action pt-2 pb-4">
                <v-btn @click="$router.push('/dashboard/create')" color="green" class="d-inline-block white--text">Create</v-btn>
              </div>
            </v-card>
            <v-card class="mt-3">
              <h2 class="py-2 text-xs-center">Join by invite</h2>
              <v-divider></v-divider>
              <div class="empty-action pb-4 px-4 text-xs-center">
                <v-text-field color="green" placeholder="Invite code" v-model="inviteCode"></v-text-field>
                <v-btn @click="queryProject" color="green" class="d-inline-block white--text">Join</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</div>
<div class="mt-5" v-else>
  <div class="loader">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</div>
</template>

<script>
import firebase, {
  db,
  FirebaseConsts
} from "@/firebaseConfig";
import {
  getUserData
} from "@/scripts/userFuncs";

export default {
  name: "dashboard",
  data: function() {
    return {
      user: null,
      // List user's projects
      projectSets: [],
      // Show/Hide the confirmation modal
      confirmJoin: false,
      // The user entered group invite code
      inviteCode: "",
      // The returned id of the group
      newGroupID: "",
      // The returned group's detail data
      inviteGroup: null,
      snackbar: false,
      color: '#B71C1C',
      mode: '',
      timeout: 6000,
      text: '',
      isLoading: true
    };
  },
  mounted() {
    this.$nextTick(function() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.user = user;
          this.$store.commit("setUID", user.uid);

          this.$bind("firestoreUser", db.collection("users").doc(user.uid)).then(
            user => {
              this.firestoreUser === user;
            }
          );
        }
      });
      // Load user data from firebase using the stored uid
      getUserData(this.$store.getters.uid)
        .then(user => {
          this.user = user;
        })
        .catch(error => {
          console.log(error);
        });
      // put code here
      this.loadProjectSets();
    })
  },
  methods: {
    loadProjectSets() {
      // Get members list of joined Projects
      this.$bind(
        "projectSets",
        db
        .collection("projects")
        .where("members", "array-contains", this.$store.getters.uid)
      ).then(projectSets => {
        this.projectSets === projectSets;
        this.isLoading = false
      });
    },
    getTime(time) {
      try {
        let hour = parseInt(time.split(":")[0]);
        let minutes = time.split(":")[1];
        return ((hour + 11) % 12) + 1 + ":" + minutes;
      } catch (err) {
        // console.log(err);
      }
    },
    getAbrev(days) {
      let string = "";
      days.forEach(day => {
        if (day === "Thursday") {
          string += day.slice(0, 2) + " ";
        } else {
          string += day.charAt(0).toUpperCase() + " ";
        }
      });
      return string;
    },
    // Add the current user's id to the new Projects
    joinProject() {
      db.collection("projects")
        .doc(this.newGroupID)
        .update({
          members: FirebaseConsts.firestore.FieldValue.arrayUnion(
            this.$store.getters.uid
          )
        })
        .then(() => {
          this.confirmJoin = false;
          this.$router.push(`/${this.newGroupID}/home`);
        });
    },
    // Search all projects to find a matching group for the invite code
    queryProject() {
      if (this.inviteCode !== "") {
        db.collection("projects")
          .where("inviteCodes", "array-contains", this.inviteCode)
          .limit(1)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.size !== 0) {
              querySnapshot.forEach(doc => {
                this.newGroupID = doc.id;
                this.confirmJoin = true;
              });
              return true;
            } else {
              this.text = 'Projects Not Found!';
              this.snackbar = true;
              //console.log("Projects Not Found!");
              return false;
            }
          })
          .then(groupFound => {
            if (groupFound) {
              db.collection("projects")
                .doc(this.newGroupID)
                .get()
                .then(doc => {
                  this.inviteGroup = doc.data();
                });
            } else {
              this.text = 'Couldn\'t run because project not found';
              this.snackbar = true;
              //console.log("didn't run because project not found");
            }
          });
      } else {
        // TODO: Show some sort of error notification
        this.text = 'You did not enter a code!!'
        this.snackbar = true;
        //console.log("You did not enter a code!!");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-container {
    border-radius: 10px;
}

.modal-btn {
    margin: 4px;
    min-width: 80px;
}

.dashboardBody {
    min-height: 64vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#undraw {
    width: 10em;
}

.loader {
    position: absolute;
    top: 50%;
    left: 48%;
}

.line {
    animation: expand 1s ease-in-out infinite;
    border-radius: 10px;
    display: inline-block;
    transform-origin: center center;
    margin: 0 3px;
    width: 1px;
    height: 25px;
}
.line:nth-child(1) {
    background: #66bb6a;
}
.line:nth-child(2) {
    animation-delay: 180ms;
    background: #7a7a7a;
}
.line:nth-child(3) {
    animation-delay: 360ms;
    background: #66bb6a;
}
.line:nth-child(4) {
    animation-delay: 540ms;
    background: #7a7a7a;
}
@keyframes expand {
    0% {
        transform: scale(1);
    }
    25% {
        transform: scale(2);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue